import React, { useEffect, useState, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { isLoggedIn } from "./../service/authService"; // Import the isLoggedIn function from your authService
import RegisterKit from './registerKit'
import { APIURL } from '../config'
import { authFetch } from '../service/apiClient'
import DynamicAccordion from './DynamicAccordion'
import CustomerReport1 from './CustomerReport1'
import Snackbar from './Snackbar'
import Loading from './loading'

const Homepage = () => {
  const [, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const [, setIsKitRegistered] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [, setYears] = useState(null);
  const [surveyData, setSurveyData] = useState("");
  const [, setErrorMessage] = useState('');
  const [kitData, setKitData] = useState(null);
  const [, setIsShowSurvey] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "info" });
  const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));

const location = useLocation(); // eslint-disable-line no-unused-vars

const fetchSurveyByEmail = useCallback(async (email) => {
    setIsLoading(true);
    try {
      const response = await authFetch(APIURL + '/getSurveyByEmail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) {
        throw new Error('Failed to fetch survey data');
      }
      const data = await response.json();
      setSurveyData(data?.data);
      const rawBirthday = data.data[0].Birthday;
      const Birthday = new Date(rawBirthday);
      const currentDate = new Date();
      let differenceInYears = currentDate.getFullYear() - Birthday.getFullYear();
      const monthDiff = currentDate.getMonth() - Birthday.getMonth();
      const dayDiff = currentDate.getDate() - Birthday.getDate();
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        differenceInYears--;
      }
      setYears(differenceInYears);
      setErrorMessage('');
      setIsLoading(false);


    } catch (error) {
      setErrorMessage('Failed to load survey data. Please try again.');
      setSnackbar({ open: true, message: "Failed to load survey data. Please try again.", type: "error" });
      setIsLoading(false);
      }
    }, []);

  const handleClose = () => {
    setShow(false);
    navigate("/survey")
  };



const goBack = () => {
  setKitData(null);
  navigate('?view=accordion', { replace: false });
};


  const showSurveyForm = (data) => {
    setIsShowSurvey(true);
    navigate(`/survey/${data?.Kit_id}`);
  };

  useEffect(() => {
    const checkLoggedIn = async () => {
      const loggedIn = await isLoggedIn();
      setIsLoggedIn(loggedIn);
      if (!loggedIn) {
        navigate("/login", { replace: true });
      } else {
        setIsLoggedIn(true);
        const token = localStorage.getItem("userInfo");
        // Retrieve the is_kit_registered value from localStorage
        const userInfo = JSON.parse(token);

        setIsKitRegistered(userInfo.is_kit_registered);
        fetchSurveyByEmail(userInfo.username || userInfo.email);
      }
    };
    checkLoggedIn();
  }, [navigate, fetchSurveyByEmail]);

  // Redirect to survey if no data exists
  useEffect(() => {
    if (!isLoading && !surveyData) {
      navigate("/survey", { replace: true });
    }
  }, [isLoading, surveyData, navigate]);



const viewReport = (data) => {
  setKitData(data);
  navigate('?view=report', { replace: false }); // Adds to history
};

  

  return (
    <div>
      <Snackbar message={snackbar.message} type={snackbar.type} open={snackbar.open} onClose={closeSnackbar} />
      {isLoading ? (
        <Loading message="Loading your pet data..." />
      ) : (
        <>
          {surveyData ? (<>
            {!kitData ? (
              <DynamicAccordion
                accordionData={surveyData}
                viewReport={viewReport}
                showSurveyForm={showSurveyForm}
              />
            ) : (
              <>
                <CustomerReport1 kitData={kitData} goBack={goBack} />
              </>
            )

            }

            {/*  */}
          </>)
            : null
          }
        </>)}

      <RegisterKit show={show} handleClose={handleClose} /> {/* Render the CustomModal with appropriate props */}
    </div>
  )
}

export default Homepage
